import React from "react";
import type {
  Question,
  ResponseStatus,
  Response,
} from "./ReviewResponseModel.types";

interface QuestionListProps {
  questions: Question[];
  selectedQuestionId: string;
  onSelectQuestion: (questionId: string) => void;
  responseStatusMap: Record<string, ResponseStatus>;
  responses: Response[];
}

const QuestionList: React.FC<QuestionListProps> = ({
  questions,
  selectedQuestionId,
  onSelectQuestion,
  responseStatusMap,
  responses,
}) => {
  const getReviewedCount = (questionId: string) => {
    const questionResponses = responses.filter(
      (r) => r.questionId === questionId,
    );
    return questionResponses.filter(
      (r) => responseStatusMap[r.id]?.userSelection,
    ).length;
  };

  return (
    <div className="review-question-list">
      <div className="review-question-list-header">
        <span className="review-question-count">
          Total Questions: {questions.length}
        </span>
      </div>

      <div className="review-question-items">
        {questions.map((question, index) => {
          const reviewedCount = getReviewedCount(question.id);
          const isSelected = question.id === selectedQuestionId;

          return (
            <div
              key={question.id}
              className={`review-question-item ${isSelected ? "selected" : ""}`}
              onClick={() => onSelectQuestion(question.id)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  onSelectQuestion(question.id);
                }
              }}
              role="button"
              tabIndex={0}
            >
              <div className="review-question-title">
                {question?.title} – {question.clauseId}
              </div>
              <div className="review-question-subtitle">
                {reviewedCount} of {question.totalResponses} reviewed
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionList;
